module.exports = __webpack_public_path__ + "img/dashboard-add-xome-name.94b47ca3.png";